import React, { useMemo } from 'react';

const SIZE = 120;
const STROKE = 8;
const R = 56;
const C = SIZE / 2;
const CIRC = 2 * Math.PI * R;

const strokeFor = (status) => {
  if (status === 'risk') return 'var(--ds-rose)';
  if (status === 'warn') return 'var(--ds-amber)';
  if (status === 'info') return 'var(--ds-blue)';
  if (status === 'purple') return 'var(--ds-purple)';
  return 'var(--ds-green)';
};

const ScoreRing = ({
  value = 0,
  max = 100,
  status = 'optimal',
  label,
  className = '',
}) => {
  const pct = useMemo(() => Math.min(1, Math.max(0, max ? value / max : 0)), [value, max]);
  const dash = CIRC * (1 - pct);

  return (
    <div className={`inline-flex flex-col items-center ${className}`.trim()}>
      <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`} aria-hidden>
        <circle cx={C} cy={C} r={R} fill="none" stroke="var(--paper-4)" strokeWidth={STROKE} />
        <circle
          cx={C}
          cy={C}
          r={R}
          fill="none"
          stroke={strokeFor(status)}
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={`${CIRC} ${CIRC}`}
          strokeDashoffset={dash}
          transform={`rotate(-90 ${C} ${C})`}
        />
        <text
          x={C}
          y={C + 5}
          textAnchor="middle"
          className="fill-gray-900"
          style={{ fontFamily: 'var(--font-mono)', fontSize: '18px', fontVariantNumeric: 'tabular-nums' }}
        >
          {value}
        </text>
      </svg>
      {label ? <div className="mt-ds-2 max-w-[9rem] text-center text-ts-xs text-gray-600">{label}</div> : null}
    </div>
  );
};

export default ScoreRing;
